import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import {
  elasticCrmEmrSyncLog,
  getLogById,
  resendLog,
  saveLogEmr,
} from "app/services/SyncCRMService";
import { makeAutoObservable } from "mobx";
import moment from "moment";
import { toast } from "react-toastify";

export default class HisToCrmHistoryAsyncStore {
  searchHisToCrmHistory = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
  };
  pageHisToCrmHistory = new PageResponse();
  selectedLog = null;
  openFormCreateOrEdit = false;

  constructor() {
    makeAutoObservable(this);
  }

  pagingeHisToCrmHistory = async () => {
    try {
      const { data } = await elasticCrmEmrSyncLog({
        ...this.searchHisToCrmHistory,
      });
      // console.log(
      //   "⏱ date paging:",
      //   moment(new Date()).format("YYYY-MM-DD HH:mm:ss.SSS")
      // );

      this.pageHisToCrmHistory = data;
    } catch (error) {
      toast.error("Lấy dữ liệu lịch sử đồng bộ có lỗi");
    }
  };

  handleResend = async (id) => {
    try {
      const { data } = await resendLog(id);
      toast.success("Thao tác đồng bộ lại thành công");
      // console.log(
      //   "📍 date before paging:",
      //   moment(new Date()).format("YYYY-MM-DD HH:mm:ss.SSS")
      // );
      setTimeout(() => {
        this.pagingeHisToCrmHistory();
      }, 800);
    } catch (error) {
      toast.error("Thao tác đồng bộ lại có lỗi");
    }
  };

  handleSubmitLog = async (values) => {
    try {
      const { data } = await saveLogEmr(values);
      toast.success("Lưu lại thành công");
      this.openFormCreateOrEdit = false;
      this.pagingeHisToCrmHistory();
    } catch (error) {
      toast.error("Lưu lại có lỗi");
    }
  };

  handleChangeFormSearch = (searchHisToCrmHistory) => {
    this.searchHisToCrmHistory = {
      ...this.searchHisToCrmHistory,
      ...searchHisToCrmHistory,
    };

    this.pagingeHisToCrmHistory();
  };

  handleOpenFormCreateOrEdit = (logId) => {
    if (Boolean(logId)) {
      getLogById(logId).then(({ data }) => {
        const { createDate, modifyDate, ...ortherData } = data;
        // const formatCreateDate = new Date(
        //   createDate?.endsWith("Z") ? createDate : createDate + "Z"
        // );
        // const formatModifyDate = new Date(
        //   modifyDate?.endsWith("Z") ? modifyDate : modifyDate + "Z"
        // );

        this.selectedLog = {
          ...ortherData,
          createDate,
          modifyDate,
        };
        this.openFormCreateOrEdit = true;
      });
    } else {
      this.selectedLog = null;
      this.openFormCreateOrEdit = true;
    }
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.selectedLog = null;
  };

  resetStore = () => {
    this.searchHisToCrmHistory = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
    };
  };
}
